import React from 'react';

import Link from 'depop/components/Link';

import { FormattedMessage } from 'react-intl';

const EventsLink = props =>
  <Link to={{ pathname: '/events/' }} {...props}>
    <FormattedMessage
      id="app.eventsLabel"
      description="Events Label"
      defaultMessage="Events"
    />
  </Link>;

export default EventsLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/EventsLink.js